// **********************************************************
// Hero Slider
// **********************************************************

const heroModuleThumb = document.querySelectorAll('[data-slider="hero-module__thumbs"]');
const heroModuleMain = document.querySelectorAll('[data-slider="hero-module__slider"]');

// Hero thumb slider
const heroModuleThumbOptions = {
  slidesPerView: 2,
  speed: 800,
  spaceBetween: 24,
  watchOverflow: true,
  breakpoints: {
    520: {
      slidesPerView: 4,
      spaceBetween: 24,
    },
    767: {
      slidesPerView: 4,
      spaceBetween: 40,
    },
  },
};

heroModuleThumb.forEach((el) => new Swiper(el, heroModuleThumbOptions));

// Hero Main Slider
const heroModuleMainOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 800,
  watchOverflow: true,
  autoHeight: true,
  loop: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  autoplay: {
    enabled: false,
    delay: 5000,
  },
  thumbs: {
    swiper: false,
  },
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  breakpoints: {
    767: {
      autoplay: {
        enabled: true,
        delay: 5000,
      },
      autoHeight: false,
    },
  },
};

heroModuleMain.forEach((el, i) => {
  const parentElem = el.closest('.hero-module');
  const arrowRight = parentElem.querySelector('.arrow-right');
  const arrowLeft = parentElem.querySelector('.arrow-left');
  heroModuleMainOptions.navigation.nextEl = arrowRight;
  heroModuleMainOptions.navigation.prevEl = arrowLeft;
  heroModuleMainOptions.thumbs.swiper = heroModuleThumb[i].swiper;
  new Swiper(el, heroModuleMainOptions);
});
